import fetch from '@/utils/fetch'

export const List = '/subsidy/desposit/goodslist'


export function savePrice (data) {
  return fetch({
    url: '/subsidy/desposit/setprice',
    method: 'post',
    data
  })
}